import React from 'react';
import Group from '../export/script/Group';
import {ErrorMessage} from 'formik';
import Error from '../../Error';
import {isPlainObject} from 'lodash';

const flattenErrorMessages = (message, errorMessages) => {
    if (message) {
        if (Array.isArray(message)) {
            return message.map((msg) => {
                if (msg) {
                    // eslint-disable-next-line guard-for-in
                    for (const key in msg) {
                        flattenErrorMessages(msg[key], errorMessages);
                    }
                }
            });
        } else if (isPlainObject(message)) {
            if (message.key != undefined) {
                errorMessages.push(message);
            } else {
                // eslint-disable-next-line guard-for-in
                for (const key in message) {
                    flattenErrorMessages(message[key], errorMessages);
                }
            }
        }
    }
};

const ScriptGeneratorClassifier2ChoicesLabel = ({scripts, items, parameters, extraFields, id, name, hasError}) => {
    return <>
        <div className={`script-label ${hasError? 'error' : ''}`}>
            {scripts.map((script, index) => (
                <div key={index} className={'group'}>
                    <Group expressions={script.expression} items={items} parameters={parameters} extraFields={extraFields} />
                </div>
            ))}
        </div>
        <ErrorMessage name={`${id}`}>
            {(message) => {
                const messages = [];
                flattenErrorMessages(message, messages);
                return messages.map(
                    (msg, index) => (msg &&
                    <div key={index}>
                        <Error reason={msg.key} reasonParams={msg.params} />
                    </div>),
                );
            }}
        </ErrorMessage>
    </>;
};

export default ScriptGeneratorClassifier2ChoicesLabel;
